import * as React from 'react';
import { useSearchParams } from 'react-router-dom';

export type TasksView = 'list' | 'board';

export function useTasksView() {
  const [searchParams, setSearchParams] = useSearchParams();

  const viewParam = searchParams.get('view');
  const view: TasksView = viewParam === 'board' || viewParam === 'kanban' ? 'board' : 'list';

  React.useEffect(() => {
    if (viewParam === 'assignee') {
      const nextParams = new URLSearchParams(searchParams);
      nextParams.set('view', 'list');
      if (!nextParams.has('groupBy')) {
        nextParams.set('groupBy', 'assignee');
      }
      setSearchParams(nextParams, { replace: true });
    } else if (viewParam === 'kanban') {
      const nextParams = new URLSearchParams(searchParams);
      nextParams.set('view', 'board');
      setSearchParams(nextParams, { replace: true });
    }
  }, [viewParam, searchParams, setSearchParams]);

  const setView = (next: TasksView) => {
    const nextParams = new URLSearchParams(searchParams);
    nextParams.set('view', next);
    setSearchParams(nextParams, { replace: true });
  };

  return { view, setView };
}
